<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.trackingCode" clearable placeholder="报工编号" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.orderCode" clearable placeholder="工单编号" style="width:160px" @keyup.enter.native="search" />
      <el-select v-model="query.trackingState" clearable placeholder="状态" style="width:110px">
        <el-option label="草稿" value="00" />
        <el-option label="已确认" value="01" />
        <el-option label="已驳回" value="02" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>

    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="trackingCode" label="报工编号" min-width="160" show-overflow-tooltip />
      <el-table-column prop="orderCode" label="工单编号" min-width="160" show-overflow-tooltip />
      <el-table-column prop="taskCode" label="工序任务" min-width="140" show-overflow-tooltip />
      <el-table-column prop="operationName" label="工序" width="120" show-overflow-tooltip />
      <el-table-column prop="shiftName" label="班次" width="100" />
      <el-table-column prop="staffName" label="人员" width="100" />
      <el-table-column prop="qtyOut" label="合格数量" width="100" align="right" />
      <el-table-column prop="qtyScrap" label="不良数量" width="90" align="right" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.trackingState === '01' ? 'success' : (row.trackingState === '02' ? 'danger' : 'info')">
            {{ stateLabel(row.trackingState) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.trackingId, true)">查看</el-button>
          <el-button type="text" :disabled="row.trackingState !== '00'" @click="openEdit(row.trackingId)">修改</el-button>
          <el-button type="text" :disabled="row.trackingState !== '00'" @click="doAccept(row)">确认</el-button>
          <el-button type="text" :disabled="row.trackingState !== '01'" @click="doUnaccept(row)">反确认</el-button>
          <el-button type="text" :disabled="row.trackingState !== '00'" @click="doReject(row)">驳回</el-button>
          <el-button type="text" style="color:#ef4444" :disabled="row.trackingState !== '00'" @click="doDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage" @size-change="onSize"
    />

    <el-dialog :title="dialogTitle" :visible.sync="visible" width="760px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" :disabled="readonly">
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="报工编号" prop="trackingCode">
              <el-input v-model="form.trackingCode" placeholder="留空自动生成" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工单" prop="orderId">
              <el-select v-model="form.orderId" filterable style="width:100%" @change="onOrderChange">
                <el-option
                  v-for="item in orderOptions"
                  :key="item.orderId"
                  :label="(item.orderCode || '') + ' / ' + (item.orderName || '')"
                  :value="item.orderId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工序任务" prop="taskId">
              <el-select v-model="form.taskId" filterable clearable style="width:100%" :disabled="!form.orderId" @change="onTaskChange">
                <el-option
                  v-for="item in taskOptions"
                  :key="item.taskId"
                  :label="(item.taskCode || '') + ' / ' + (item.operationName || '')"
                  :value="item.taskId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工序" prop="operationId">
              <el-select v-model="form.operationId" filterable clearable style="width:100%">
                <el-option
                  v-for="item in operationOptions"
                  :key="item.operationId"
                  :label="(item.operationNumber || '') + ' / ' + (item.operationName || '')"
                  :value="item.operationId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="班次">
              <el-select v-model="form.shiftId" filterable clearable style="width:100%">
                <el-option v-for="item in shiftOptions" :key="item.shiftId" :label="item.shiftName" :value="item.shiftId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报工人员">
              <el-select v-model="form.staffId" filterable clearable style="width:100%">
                <el-option
                  v-for="item in staffOptions"
                  :key="item.staffId"
                  :label="(item.staffNumber || '') + ' / ' + (item.staffName || '')"
                  :value="item.staffId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合格数量" prop="qtyOut">
              <el-input-number v-model="form.qtyOut" :min="0" :precision="5" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产出批次">
              <el-input v-model="form.batchNo" maxlength="64" :placeholder="batchPlaceholder" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="不良数量">
              <el-input-number v-model="form.qtyScrap" :min="0" :precision="5" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="不良原因">
              <el-select v-model="form.scrapReasonId" filterable clearable placeholder="有不良数量时必选" style="width:100%">
                <el-option
                  v-for="item in reasonOptions"
                  :key="item.reasonId"
                  :label="(item.reasonCode || '') + ' / ' + (item.reasonName || '')"
                  :value="item.reasonId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="说明"><el-input v-model="form.description" type="textarea" :rows="2" /></el-form-item>
          </el-col>
          <el-col v-if="showRework" :span="24">
            <el-form-item label="不合格转返工">
              <el-switch v-model="needRework" :disabled="readonly" />
            </el-form-item>
          </el-col>
          <el-col v-if="qcItems.length" :span="24">
            <el-form-item label="质量点检">
              <div class="qc-hint">来自产品属性主数据。不合格会记入报工异常。</div>
              <div v-for="item in qcItems" :key="item.attributeId" class="qc-row">
                <span class="qc-name">{{ item.attrName }}</span>
                <el-input v-if="item.valueType === '02'" v-model="item.value" size="small" placeholder="数值" :disabled="readonly" class="qc-value" />
                <el-radio-group v-else v-model="item.result" size="small" :disabled="readonly">
                  <el-radio-button label="ok">合格</el-radio-button>
                  <el-radio-button label="ng">不合格</el-radio-button>
                </el-radio-group>
                <el-input
                  v-if="item.result === 'ng' || item.valueType === '02'"
                  v-model="item.note"
                  size="small"
                  placeholder="备注（不合格必填）"
                  :disabled="readonly"
                  class="qc-note"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div v-if="guideDocs.length || guideChecks.length || photoList.length || !readonly" class="guide-box">
        <div v-if="guideDocs.length" class="guide-block">
          <div class="qc-hint">图纸和作业指导</div>
          <el-button v-for="doc in guideDocs" :key="doc.docId || doc.attachmentId" type="text" @click="openDoc(doc)">
            {{ doc.docType === '02' ? '作业指导' : '图纸' }} {{ doc.fileName || '' }}
          </el-button>
        </div>
        <div v-if="guideChecks.length" class="guide-block">
          <div class="qc-hint">检测数据。超出上下限只提示，不拦截报工。</div>
          <div v-for="item in guideChecks" :key="item.checkId" class="qc-row">
            <span class="qc-name">{{ item.checkName }}<template v-if="item.unit">（{{ item.unit }}）</template></span>
            <el-input v-model="item.value" size="small" placeholder="数值" :disabled="readonly" class="qc-value" />
            <span class="qc-hint">{{ limitText(item) }}</span>
            <span v-if="outOfLimit(item)" class="over">超出范围</span>
          </div>
        </div>
        <div v-if="photoList.length || !readonly" class="guide-block">
          <div class="qc-hint">现场照片</div>
          <div class="photo-list">
            <div v-for="(photo, idx) in photoList" :key="photo.attachmentId || idx" class="photo-item">
              <el-image v-if="photo.url && /^https?:\/\//i.test(photo.url)" :src="photo.url" :preview-src-list="photoUrls" fit="cover" class="photo-img" />
              <el-button v-else type="text" @click="openDoc(photo)">{{ photo.fileName || '照片' }}</el-button>
              <el-button v-if="!readonly" type="text" style="color:#ef4444" @click="photoList.splice(idx, 1)">移除</el-button>
            </div>
            <el-upload v-if="!readonly" :show-file-list="false" accept="image/*" :http-request="uploadPhoto">
              <el-button size="small" plain type="primary" :disabled="photoList.length >= 9">拍照/上传</el-button>
            </el-upload>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="visible = false">{{ readonly ? '关闭' : '取消' }}</el-button>
        <el-button v-if="!readonly" type="primary" :loading="saving" @click="submit">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="确认报工" :visible.sync="issueVisible" width="980px" :close-on-click-modal="false">
      <p style="margin:0 0 12px;color:#606266">
        {{ issueHint }}
      </p>
      <el-table v-if="issueLines.length" :data="issueLines" border size="mini" max-height="360" v-loading="issueLoading">
        <el-table-column prop="materialCode" label="物料编码" min-width="120" show-overflow-tooltip />
        <el-table-column prop="materialName" label="物料名称" min-width="140" show-overflow-tooltip />
        <el-table-column label="本次扣料" width="110" align="right">
          <template slot-scope="{ row }">{{ formatQty(row.quantity) }}</template>
        </el-table-column>
        <el-table-column label="可用" width="90" align="right">
          <template slot-scope="{ row }">
            <span :style="{ color: usableShort(row) ? '#ef4444' : '' }">{{ formatQty(usableOf(row)) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="投入批次" min-width="140">
          <template slot-scope="{ row }">
            <el-input v-model="row.batchNo" size="mini" maxlength="64" placeholder="可选" :disabled="Number(row.quantity) <= 0" />
          </template>
        </el-table-column>
        <el-table-column label="扣料仓库" min-width="200">
          <template slot-scope="{ row }">
            <el-select v-model="row.wareHouseId" filterable clearable size="mini" style="width:100%" :disabled="Number(row.quantity) <= 0">
              <el-option v-for="w in warehouses" :key="w.wareHouseId" :label="whLabel(row, w)" :value="w.wareHouseId" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="替代料" width="120" align="center">
          <template slot-scope="{ row }">
            <el-button v-if="row.substituteProductId" type="text" :disabled="Number(row.quantity) <= 0" @click="useSubstitute(row)">
              {{ row.materialId === row.sourceMaterialId ? ('用替代 ' + (row.substituteProductNumber || '')) : '用原物料' }}
            </el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      <div v-else v-loading="issueLoading" style="color:#909399">本次没有需要扣减的物料。</div>
      <div slot="footer">
        <el-button @click="issueVisible = false">取消</el-button>
        <el-button type="primary" :loading="issueSaving" :disabled="issueLoading" @click="submitAccept">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listTracking, getTracking, saveTracking, updateTracking,
  deleteTracking, previewTrackingIssue, acceptTracking, unacceptTracking, rejectTracking
} from '../../api/tracking'
import { selectEnabledWareHouse } from '../../api/warehouse'
import { selectProductionOrder } from '../../api/productionOrder'
import { selectOrderTask } from '../../api/orderTask'
import { selectOperation, getOperationGuide } from '../../api/operation'
import { selectShift } from '../../api/shift'
import { selectStaff } from '../../api/staff'
import { selectAnomalyReason } from '../../api/anomalyReason'
import { selectAttribute } from '../../api/attribute'
import { listTrackingAnomalyByTracking, saveTrackingAnomaly, reworkTrackingAnomaly } from '../../api/trackingAnomaly'
import request from '../../api/request'
import { elUploadHttpRequest } from '../../utils/ossUpload'

const STATE_MAP = { '00': '草稿', '01': '已确认', '02': '已驳回' }

function emptyForm() {
  return {
    trackingId: '', trackingCode: '', orderId: '', taskId: '', operationId: '',
    shiftId: '', staffId: '', qtyOut: 0, qtyScrap: 0, batchNo: '', scrapReasonId: '', description: '', version: 0, lineList: []
  }
}

function splitTrackingNote(text) {
  let raw = text || ''
  let rework = false
  if (raw === '转返工') {
    return { base: '', qcRaw: '', rework: true }
  }
  if (raw.endsWith(' | 转返工')) {
    rework = true
    raw = raw.slice(0, -' | 转返工'.length)
  }
  const mark = ' | 点检 '
  const idx = raw.lastIndexOf(mark)
  if (raw.indexOf('点检 ') === 0) {
    return { base: '', qcRaw: raw, rework }
  }
  if (idx >= 0) {
    return { base: raw.slice(0, idx), qcRaw: raw.slice(idx + 3), rework }
  }
  return { base: raw, qcRaw: '', rework }
}

function qcFailedNames(text) {
  const parsed = splitTrackingNote(text)
  if (!parsed.qcRaw) return []
  const body = parsed.qcRaw.replace(/^点检\s*/, '')
  const names = []
  body.split('；').forEach(part => {
    const textPart = part.trim()
    const matched = textPart.match(/^(.+?):不合格/)
    if (matched) names.push(textPart)
  })
  return names
}

export default {
  name: 'TrackingPage',
  components: { ListPagination },
  data() {
    return {
      query: { trackingCode: '', orderCode: '', trackingState: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      visible: false, readonly: false, saving: false, form: emptyForm(),
      rules: {
        orderId: [{ required: true, message: '请选择工单', trigger: 'change' }],
        taskId: [{ required: true, message: '请选择工序任务', trigger: 'change' }],
        operationId: [{ required: true, message: '请选择工序', trigger: 'change' }],
        qtyOut: [{ required: true, message: '请填写合格数量', trigger: 'change' }]
      },
      orderOptions: [], taskOptions: [], operationOptions: [], shiftOptions: [], staffOptions: [], reasonOptions: [],
      qcItems: [], needRework: true, noteSource: '',
      guideDocs: [], guideChecks: [], photoList: [],
      warehouses: [],
      issueVisible: false, issueLoading: false, issueSaving: false, issueLines: [], issueRow: null
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看报工'
      return this.form.trackingId ? '修改报工' : '新增报工'
    },
    photoUrls() {
      return this.photoList.map(photo => photo.url).filter(url => /^https?:\/\//i.test(url || ''))
    },
    selectedOrder() {
      return this.orderOptions.find(x => x.orderId === this.form.orderId) || null
    },
    isLastTask() {
      if (!this.form.taskId || !this.taskOptions.length) return false
      const last = this.taskOptions[this.taskOptions.length - 1]
      return last && last.taskId === this.form.taskId
    },
    batchRequired() {
      return !!(this.isLastTask && this.selectedOrder && this.selectedOrder.batchEvidence === '1')
    },
    batchPlaceholder() {
      if (!this.isLastTask) return '末道工序报工时填写'
      if (this.batchRequired) return '请填写产出批次：' + (this.selectedOrder.productNumber || '')
      return '启用批次管理时必填'
    },
    showRework() {
      if (Number(this.form.qtyScrap) > 0) return true
      return this.qcItems.some(item => item.result === 'ng')
    },
    issueHint() {
      const row = this.issueRow || {}
      const code = row.trackingCode || ''
      const qty = this.formatQty(row.qtyOut)
      if (!this.issueLines.length) {
        return (code ? code + '：' : '') + '合格数量 ' + qty + '。本次没有需要扣减的物料，确认后更新完成量。'
      }
      return (code ? code + '：' : '') + '合格数量 ' + qty + '。请确认扣料仓库。半成品默认半成品仓，其他物料默认组件仓。数量为 0 表示先前已领足，本次不再扣。'
    }
  },
  created() {
    selectProductionOrder().then(res => {
      const list = res.data || []
      this.orderOptions = list.filter(o => o.orderState === '01' || o.orderState === '02')
    }).catch(() => {})
    selectOperation().then(res => { this.operationOptions = res.data || [] }).catch(() => {})
    selectShift().then(res => { this.shiftOptions = res.data || [] }).catch(() => {})
    selectStaff().then(res => { this.staffOptions = res.data || [] }).catch(() => {})
    selectAnomalyReason().then(res => { this.reasonOptions = res.data || [] }).catch(() => {})
    selectEnabledWareHouse().then(res => { this.warehouses = res.data || [] }).catch(() => {})
    this.load()
  },
  methods: {
    stateLabel(s) { return STATE_MAP[s] || s || '-' },
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listTracking({
        currentPage: this.page, pageSize: this.pageSize,
        trackingCode: this.query.trackingCode,
        orderCode: this.query.orderCode,
        trackingState: this.query.trackingState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id, readonly) {
      this.readonly = !!readonly
      this.form = emptyForm()
      this.taskOptions = []
      this.needRework = true
      this.qcItems = []
      this.noteSource = ''
      this.guideDocs = []
      this.guideChecks = []
      this.photoList = []
      this.visible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      selectAttribute().then(res => {
        this.qcItems = (res.data || []).slice(0, 12).map(a => ({
          attributeId: a.attributeId,
          attrName: a.attrName,
          valueType: a.valueType || '01',
          result: '',
          value: '',
          note: ''
        }))
        this.applySavedNote()
      }).catch(() => { this.qcItems = [] })
      if (!id) return
      getTracking(id).then(res => {
        this.form = Object.assign(emptyForm(), res.data || {})
        this.noteSource = this.form.description || ''
        this.applySavedNote()
        this.photoList = (this.form.photoList || []).slice()
        if (this.form.orderId) this.loadTasks(this.form.orderId)
        if (this.form.operationId) this.loadGuide(this.form.operationId, this.form.checkList || [])
      })
    },
    applySavedNote() {
      const parsed = splitTrackingNote(this.noteSource)
      this.form.description = parsed.base
      if (this.noteSource) this.needRework = parsed.rework
      if (!parsed.qcRaw || !this.qcItems.length) return
      const body = parsed.qcRaw.replace(/^点检\s*/, '')
      body.split('；').forEach(part => {
        const text = part.trim()
        if (!text) return
        const num = text.match(/^(.+?)=([^()]*)(?:\((.*)\))?$/)
        const pass = text.match(/^(.+?):(合格|不合格)(?:\((.*)\))?$/)
        const hit = num || pass
        if (!hit) return
        const item = this.qcItems.find(q => q.attrName === hit[1])
        if (!item) return
        if (num) {
          item.value = (hit[2] || '').trim()
          item.note = hit[3] || ''
        } else {
          item.result = hit[2] === '不合格' ? 'ng' : 'ok'
          item.note = hit[3] || ''
        }
      })
    },
    buildQcSummary() {
      const parts = []
      const failed = []
      this.qcItems.forEach(item => {
        if (item.valueType === '02') {
          if (item.value === '' || item.value === null || item.value === undefined) return
          parts.push(item.attrName + '=' + item.value + (item.note ? '(' + item.note + ')' : ''))
          return
        }
        if (!item.result) return
        const label = item.result === 'ok' ? '合格' : '不合格'
        parts.push(item.attrName + ':' + label + (item.note ? '(' + item.note + ')' : ''))
        if (item.result === 'ng') failed.push(item)
      })
      return { parts, failed }
    },
    onOrderChange(orderId) {
      this.form.taskId = ''
      this.form.operationId = ''
      this.loadTasks(orderId)
    },
    loadTasks(orderId) {
      if (!orderId) { this.taskOptions = []; return }
      selectOrderTask(orderId).then(res => { this.taskOptions = res.data || [] }).catch(() => { this.taskOptions = [] })
    },
    onTaskChange(taskId) {
      const t = this.taskOptions.find(x => x.taskId === taskId)
      if (t && t.operationId) {
        this.form.operationId = t.operationId
        this.loadGuide(t.operationId, [])
      }
    },
    loadGuide(operationId, saved) {
      if (!operationId) {
        this.guideDocs = []
        this.guideChecks = []
        return
      }
      getOperationGuide(operationId).then(res => {
        const body = res.data || {}
        this.guideDocs = body.docs || []
        const byId = {}
        ;(saved || []).forEach(row => {
          if (row && row.checkId) byId[row.checkId] = row
        })
        this.guideChecks = (body.checks || []).map(item => {
          const hit = byId[item.checkId]
          return Object.assign({}, item, {
            value: hit && hit.valueNum != null ? String(hit.valueNum) : ''
          })
        })
      }).catch(() => {})
    },
    limitText(item) {
      if (!item) return ''
      const parts = []
      if (item.lowerLimit != null && item.lowerLimit !== '') parts.push('下限 ' + item.lowerLimit)
      if (item.upperLimit != null && item.upperLimit !== '') parts.push('上限 ' + item.upperLimit)
      return parts.join(' ')
    },
    outOfLimit(item) {
      if (!item || item.value === '' || item.value == null) return false
      const n = Number(item.value)
      if (Number.isNaN(n)) return false
      if (item.lowerLimit != null && item.lowerLimit !== '' && n < Number(item.lowerLimit)) return true
      if (item.upperLimit != null && item.upperLimit !== '' && n > Number(item.upperLimit)) return true
      return false
    },
    openDoc(doc) {
      const url = (doc && doc.url) || ''
      if (/^https?:\/\//i.test(url)) {
        window.open(url)
        return
      }
      const path = url.replace(/^\/api/, '')
      if (!path) return
      request.get(path, { responseType: 'blob' }).then(res => {
        window.open(URL.createObjectURL(res.data))
      })
    },
    uploadPhoto(options) {
      if (this.photoList.length >= 9) {
        this.$message.warning('照片最多 9 张')
        return
      }
      elUploadHttpRequest(options).then(res => {
        const data = (res && res.data) || {}
        if (!data.id) return
        this.photoList.push({
          attachmentId: data.id,
          fileName: data.fileName,
          url: data.url
        })
      }).catch(() => {})
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        if (this.form.qtyScrap > 0 && !this.form.scrapReasonId) {
          this.$message.warning('存在不良数量时，请选择不良原因')
          return
        }
        if (this.batchRequired && !(this.form.batchNo && String(this.form.batchNo).trim())) {
          this.$message.warning('产品已启用批次管理，请填写产出批次：' + (this.selectedOrder.productNumber || ''))
          return
        }
        const qc = this.buildQcSummary()
        const ngWithoutNote = qc.failed.find(item => !String(item.note || '').trim())
        if (ngWithoutNote) {
          this.$message.warning('不合格项请填写备注：' + ngWithoutNote.attrName)
          return
        }
        const checks = []
        for (const item of this.guideChecks) {
          const text = String(item.value == null ? '' : item.value).trim()
          if (!text) continue
          const n = Number(text)
          if (Number.isNaN(n)) {
            this.$message.warning('检测数据请填数字：' + item.checkName)
            return
          }
          checks.push({
            checkId: item.checkId,
            checkName: item.checkName,
            unit: item.unit,
            valueNum: n,
            lowerLimit: item.lowerLimit,
            upperLimit: item.upperLimit
          })
        }
        const extras = []
        if (qc.parts.length) extras.push('点检 ' + qc.parts.join('；'))
        if (this.showRework && this.needRework) extras.push('转返工')
        const base = (this.form.description || '').trim()
        const payload = Object.assign({}, this.form, {
          description: [base, ...extras].filter(Boolean).join(' | '),
          checkList: checks,
          photoList: this.photoList.map(photo => ({
            attachmentId: photo.attachmentId,
            fileName: photo.fileName
          }))
        })
        this.saving = true
        const req = payload.trackingId ? updateTracking(payload) : saveTracking(payload)
        req.then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.load()
        }).finally(() => { this.saving = false })
      })
    },
    formatQty(v) {
      if (v === null || v === undefined || v === '') return '0'
      const n = Number(v)
      if (Number.isNaN(n)) return String(v)
      return String(parseFloat(n.toFixed(5)))
    },
    usableOf(row) {
      const stocks = row.stocks || []
      const hit = stocks.find(s => s.wareHouseId === row.wareHouseId)
      return hit ? hit.usableQty : 0
    },
    usableShort(row) {
      return Number(row.quantity) > 0 && Number(this.usableOf(row)) < Number(row.quantity)
    },
    useSubstitute(row) {
      if (!row || !row.substituteProductId) return
      const next = {
        materialId: row.substituteProductId,
        materialCode: row.substituteProductNumber || '',
        materialName: row.substituteProductName || '',
        stocks: row.substituteStocks || [],
        substituteProductId: row.materialId,
        substituteProductNumber: row.materialCode || '',
        substituteProductName: row.materialName || '',
        substituteStocks: row.stocks || []
      }
      Object.assign(row, next)
    },
    whLabel(row, w) {
      const stocks = row.stocks || []
      const hit = stocks.find(s => s.wareHouseId === w.wareHouseId)
      if (!hit) return w.wareHouseName
      return w.wareHouseName + '（可用 ' + this.formatQty(hit.usableQty) + '）'
    },
    doAccept(row) {
      this.issueRow = row
      this.issueLines = []
      this.issueVisible = true
      this.issueLoading = true
      previewTrackingIssue(row.trackingId).then(res => {
        this.issueLines = (res.data || []).map(item => Object.assign({}, item))
      }).catch(() => {
        this.issueVisible = false
      }).finally(() => { this.issueLoading = false })
    },
    submitAccept() {
      const row = this.issueRow
      if (!row) return
      const missing = this.issueLines.find(line => Number(line.quantity) > 0 && !line.wareHouseId)
      if (missing) {
        this.$message.warning('请选择扣料仓库：' + (missing.materialName || missing.materialCode || ''))
        return
      }
      this.issueSaving = true
      acceptTracking({
        trackingId: row.trackingId,
        version: row.version,
        issueLines: this.issueLines.map(line => ({
          sourceMaterialId: line.sourceMaterialId || line.materialId,
          materialId: line.materialId,
          wareHouseId: line.wareHouseId || '',
          batchNo: line.batchNo || ''
        }))
      }).then(() => {
        return this.recordQcResult(row)
      }).then(() => {
        this.$message.success('已确认')
        this.issueVisible = false
        this.load()
      }).finally(() => { this.issueSaving = false })
    },
    recordQcResult(row) {
      const desc = (row && row.description) || ''
      const failed = qcFailedNames(desc)
      const rework = desc.indexOf('转返工') >= 0
      if (!failed.length && !rework) return Promise.resolve()
      const reasonId = row.scrapReasonId || (this.reasonOptions[0] && this.reasonOptions[0].reasonId)
      return listTrackingAnomalyByTracking(row.trackingId).then(res => {
        const list = res.data || []
        const hit = list.find(item => item && !item.reworkTaskId)
        if (hit) {
          return rework ? reworkTrackingAnomaly(hit.anomalyId) : null
        }
        if (!failed.length || !row.productId || !reasonId) return null
        const qty = Number(row.qtyScrap) > 0 ? row.qtyScrap : (Number(row.qtyOut) > 0 ? row.qtyOut : 1)
        return saveTrackingAnomaly({
          trackingId: row.trackingId,
          orderId: row.orderId,
          productId: row.productId,
          reasonId,
          quantity: qty,
          explanation: '点检不合格：' + failed.join('；')
        }).then(saved => {
          const anomalyId = saved && saved.data
          if (rework && anomalyId) return reworkTrackingAnomaly(anomalyId)
        })
      }).catch(() => {})
    },
    doUnaccept(row) {
      this.$confirm('反确认该报工？将回退完成量，并冲回自动生成的领料、生产入库单据。', '提示', { type: 'warning' }).then(() => {
        unacceptTracking({ trackingId: row.trackingId, version: row.version }).then(() => {
          this.$message.success('已反确认')
          this.load()
        })
      }).catch(() => {})
    },
    doReject(row) {
      this.$confirm('驳回该报工？', '提示', { type: 'warning' }).then(() => {
        rejectTracking({ trackingId: row.trackingId, version: row.version }).then(() => {
          this.$message.success('已驳回')
          this.load()
        })
      }).catch(() => {})
    },
    doDelete(row) {
      this.$confirm('确定删除？关联的报工异常、检测数据和照片会一并删除。', '提示', { type: 'warning' }).then(() => {
        deleteTracking([row.trackingId]).then(() => {
          this.$message.success('已删除')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.qc-hint { color: #909399; font-size: 12px; line-height: 1.4; margin-bottom: 8px; }
.qc-row { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; margin-bottom: 8px; }
.qc-name { min-width: 88px; color: #303133; }
.qc-value { width: 120px; }
.qc-note { width: 220px; }
.guide-box { padding: 0 8px 8px 100px; }
.guide-block { margin-bottom: 12px; }
.photo-list { display: flex; flex-wrap: wrap; gap: 12px; align-items: flex-start; }
.photo-item { display: flex; flex-direction: column; align-items: flex-start; }
.photo-img { width: 72px; height: 72px; border-radius: 6px; }
.over { color: #ef4444; font-size: 12px; }
</style>
